import { createApp } from 'vue';
import 'core-js/stable'; 
import 'regenerator-runtime/runtime';
import moment from 'moment';
import App from 'Components/App.vue';
import router from './router.js';
import store from 'Store/index.js';

// styles import
import 'bootstrap/dist/css/bootstrap.min.css';
import '../sass/main.scss';
import 'primeicons/primeicons.css'

import VueSimpleSVG from 'vue3-simple-svg'


const app = createApp(App);

app.config.globalProperties.$moment = moment;

app.use(VueSimpleSVG);
app.use(router);
app.use(store);

app.mount('#app');
